<script setup lang="ts">
import SidebarMenu from "@/components/SidebarMenu.vue";
import PageFooter from "@/components/PageFooter.vue";
import CalculatorSidebarItems from "@/components/sidebar/CalculatorSidebarItems.vue";
import PageHeader from "@/components/headers/PageHeader.vue";
import BlogButton from "@/components/buttons/BlogButton.vue";
import { useSafeBack } from "@/utils/useSafeBack";
import { ROUTE_NAMES } from "@/constants/routeNames";
import pageBg from "@/assets/calculators/calculator_bg.webp";
import { ref, defineProps, withDefaults } from "vue";

withDefaults(defineProps<{ withOverflow?: boolean; showBgImage?: boolean }>(), {
  showBgImage: true,
});

const { safeBack } = useSafeBack();

const isMenuOpen = ref(false);
</script>

<template>
  <div class="flex xl:flex-row flex-col h-screen relative">
    <SidebarMenu
      :show-blog-btn="false"
      :is-menu-open="isMenuOpen"
      @toggle-menu="isMenuOpen = !isMenuOpen"
    >
      <CalculatorSidebarItems @close-menu="isMenuOpen = false" />
    </SidebarMenu>

    <main class="flex flex-col flex-1 relative overflow-hidden">
      <PageHeader @close="safeBack(ROUTE_NAMES.HOME)" class="hidden xl:flex">
        <template #header-content>
          <BlogButton class="hidden xl:flex" />
        </template>
      </PageHeader>
      <section
        :class="[
          'flex-1 bg-secondary bg-cover bg-center',
          { 'overflow-hidden': !withOverflow },
        ]"
        :style="showBgImage ? { backgroundImage: `url(${pageBg})` } : {}"
      >
        <slot />
      </section>
      <PageFooter />
    </main>
  </div>
</template>
